// Сметката зад „Конфигурации": кой склад е ДЕЙСТВАЩИЯТ и какво точно отива в
// `PUT /inventory/settings`. Отделно от страницата, за да е закотвено с тест:
// BE заменя ДВЕТЕ полета наведнъж (upsert на целия ред), затова частичен PUT
// би занулил другото.

type Warehouse = { id: number };

export type SettingsValues = {
  vatRegistered: boolean;
  defaultWarehouseId: number | null;
};

// Складът, който модулът наистина ползва: записаният, а ако няма такъв (или
// вече не съществува) — първият по id, точно както решава `Inventory.tsx`.
// Иначе при един склад полето стоеше празно, докато целият модул отдавна
// работи с него.
//
// Последният fallback е ЗАПИСАНИЯТ, не `null`: докато списъкът със складове
// още се зарежда, „не го намирам в списъка" не значи „изтрит е", а записът
// праща и двете полета — иначе запис на ДДС отметката в тази секунда би
// занулил зададения склад.
export const effectiveWarehouseId = (
  storedId: number | null,
  warehouses: Warehouse[],
): number | null =>
  storedId != null && warehouses.some((warehouse) => warehouse.id === storedId)
    ? storedId
    : (warehouses[0]?.id ?? storedId);

// Пълните настройки за запис: текущите (както се показват) + промяната.
export const settingsPayload = (
  current: SettingsValues,
  patch: Partial<SettingsValues>,
): SettingsValues => ({
  vatRegistered: patch.vatRegistered ?? current.vatRegistered,
  defaultWarehouseId:
    patch.defaultWarehouseId !== undefined
      ? patch.defaultWarehouseId
      : current.defaultWarehouseId,
});
